import { Heading, Text } from '@growtherapy/sprout-ui';

import NotFoundBlocks from '../assets/not-found-blocks.svg';

function SubtitleDefault() {
  return <>Our page is out of order at the moment. Please try again later, or contact support through your portal.</>;
}

export type ErrorPageProps = {
  errorCode?: number;
  title?: string;
  subtitle?: string | JSX.Element;
  children?: React.ReactNode;
  isRebrand?: boolean;
};

export function ErrorPageContent({
  title = 'An unexpected error occurred',
  subtitle = <SubtitleDefault />,
  errorCode,
  children,
  isRebrand,
}: ErrorPageProps) {
  return (
    <div className='flex h-full w-full flex-col items-center justify-center gap-6 bg-neutral-300 px-16'>
      {!isRebrand && <img src={NotFoundBlocks} alt='' />}
      {errorCode && (
        <Text variant='lg' className='text-neutral-700 font-medium text-center'>
          {errorCode}
        </Text>
      )}
      <Heading variant='3xl' className='font-normal text-center' as='h1'>
        {title}
      </Heading>
      <Text as='div' className='text-neutral-700 text-center'>
        {subtitle}
      </Text>
      {children}
    </div>
  );
}
